import { Token } from '@pancakeswap/sdk'
import { parseUnits } from 'ethers/lib/utils'
import { SerializedToken } from '../actions'

export function serializeToken(token: Token): SerializedToken {
  return {
    chainId: token.chainId,
    address: token.address,
    decimals: token.decimals,
    symbol: token.symbol,
    name: token.name,
  }
}

export function deserializeToken(serializedToken: SerializedToken): Token {
  return new Token(
    serializedToken.chainId,
    serializedToken.address,
    serializedToken.decimals,
    serializedToken.symbol,
    serializedToken.name,
  )
}

export enum GAS_PRICE {
  default = '10000000',
  fast = '60000000',
  instant = '70000000',
  testnet = '100000000',
}

export const GAS_PRICE_GWEI = {
  default: parseUnits(GAS_PRICE.default, 'wei').toString(),
  fast: parseUnits(GAS_PRICE.fast, 'wei').toString(),
  instant: parseUnits(GAS_PRICE.instant, 'wei').toString(),
  testnet: parseUnits(GAS_PRICE.testnet, 'wei').toString(),
}

export const GAS_PRICE_WEI = {
  default: parseUnits(GAS_PRICE.default, 'wei').toString(),
  fast: parseUnits(GAS_PRICE.fast, 'wei').toString(),
  instant: parseUnits(GAS_PRICE.instant, 'wei').toString(),
  testnet: parseUnits(GAS_PRICE.testnet, 'wei').toString(),
}